import type { ChangelogEntry } from "../types";

/** VIB-2866: budsjettpostene på Økonomi følger tilbudets rekkefølge. */
export const BUDSJETT_REKKEFOLGE_2026_10: ChangelogEntry = {
  id: "2026-10-12-budsjett-rekkefolge",
  date: "2026-10-12",
  title: "Budsjettpostene står i samme rekkefølge som i tilbudet",
  summary:
    "Under Økonomi og Timetildeling kom postene i hver fase i tilfeldig rekkefølge. Nå følger de rekkefølgen fra tilbudet.",
  sections: [
    {
      heading: "Inne på et prosjekt",
      minRole: "user",
      items: [
        {
          title: "Postene kom i tilfeldig rekkefølge",
          kind: "rettet",
          body: "Når et tilbud ble gjort om til prosjekt, fikk alle budsjettpostene samme tidsstempel, og rekkefølgen innen hver fase ble tilfeldig. Nå tar prosjektet med seg rekkefølgen fra tilbudet, så Regissør, Produsent og DOP står der du satte dem. Poster du legger til etterpå havner nederst i fasen, i den rekkefølgen du la dem til.",
        },
      ],
    },
  ],
};
